import {DomainEvent} from './DomainEvent';
import type {EntityExportRequest} from './EntityExportRequest';

export interface CompetitionSeasonsExportRequest extends EntityExportRequest {
  /** the id of the competition season to export, defaults to all competition seasons */
  readonly id?: number;
  /** whether only active or only inactive competition seasons shall be exported, defaults to all competition seasons */
  readonly active?: boolean;
  /** the id of the district of which to export the related competition seasons, defaults to all competition seasons */
  readonly districtId?: number;
}

/**
 * This event can be fired to indicate that a service requires competition seasons, optionally with a specific active flag.
 * Another service that is eligible to provide this info will put batches of the requested models into
 * the specified S3 {@see CompetitionSeasonsExportRequest.targetBucket} using
 * the {@see CompetitionSeasonsExportRequest.transactionId} as prefix (sub-folder).
 */
export class CompetitionSeasonsExportRequested extends DomainEvent<CompetitionSeasonsExportRequest> {}
